import { createContext, useContext, useState, useEffect } from "react";
import { apiFetchAdmin } from '../../hooks/apiFetch';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

// import Cookies from 'js-cookie';

const AdminAdvServiceContext = createContext();

export function AdminAdvServiceProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [settingAdvServices, setSettingAdvServices] = useState("");

    const navigate = useNavigate();

    useEffect(() => {
        if (!Cookies.get('adminToken')) {
            navigate("/admin/adminLogin")
        }

        async function fetchAdvService() {
            setLoading(true);
            try {
                const advServiceData = await apiFetchAdmin(`${process.env.REACT_APP_MASAR_API_URL}/services?page=${currentPage}&limit=9&type=advanced`);
                setSettingAdvServices(advServiceData);

            } catch (err) {
                setSettingAdvServices(null)

            } finally {
                setLoading(false);
            }
        }
        fetchAdvService();
    }, [navigate, currentPage]);


    return (
        <AdminAdvServiceContext.Provider
            value={{
                loading, setLoading, currentPage, setCurrentPage, settingAdvServices, setSettingAdvServices
            }}>
            {children}
        </AdminAdvServiceContext.Provider>
    );
}

export function useAdminAdvService() {
    return useContext(AdminAdvServiceContext);
}